import { anonymousAccessPath } from 'core/endspoints/anonymousAccess';
import api from 'services/api';

export const RevokeAnonymousAccess = async (anonymousAccessId: string): Promise<void> => {
  const path = anonymousAccessPath(anonymousAccessId);
  await api.delete(path);
};
